export default {
  data() {
    return {
      openUrl: '/form/todo',
      openQueryList: ['processInstanceId', 'taskId', 'modelKey', 'nodeId'],
      // 转办
      showTurnDialog: false,
      loading: {
        turn: false
      },
      turnParam: {
        taskId: '',
        submittedBy: localStorage.employeeNo
      },
      // 审批/驳回
      showAudit: false,
      auditData: {
        value: {},
        title: '',
        operatorType: ''
      },
      // 传阅
      showCirculate: false,
      circulateData: {}
    }
  },
  methods: {
    handleClick(handle, row) {
      this[handle](row)
    },
    // 审批 同意
    audit(row) {
      this.auditData = {
        value: row,
        title: '审批',
        operatorType: 'APPROVE_FORM'
      }
      this.showAudit = true
    },
    // 驳回
    reject(row) {
      this.auditData = {
        value: row,
        title: '驳回',
        operatorType: 'REJECT'
      }
      this.showAudit = true
    },
    // 收回
    withdraw(row) {
      this.$api.formModel.submitForm({
        processInstanceId: row.processInstanceId,
        operatorType: 'WITHDRAW',
        taskId: row.taskId,
        submittedBy: localStorage.employeeNo
      }).then(data => {
        this.$message.success('收回成功！')
      })
    },
    // 转办
    turn(row) {
      this.showTurnDialog = true
      this.turnParam.taskId = row.taskId
    },
    submitTurn(data) {
      this.loading.turn = true
      this.$api.personalOffice.turn(Object.assign(this.turnParam, data)).then(data => {
        this.$message.success('转办成功！')
        this.showTurnDialog = false
        this.checkSearch()
      }).finally(() => {
        this.loading.turn = false
      })
    },
    // 传阅
    circulate(row) {
      this.circulateData = row
      this.showCirculate = true
    },
    open(row) {
      const paramsList = [
        { key: 'processInstanceId', val: row.processInstanceId || '' },
        { key: 'taskId', val: row.taskId || '' },
        { key: 'modelKey', val: row.modelKey || row.processDefinitionKey || '' },
        { key: 'nodeId', val: row.taskDefKey || '' }
      ]
      const url = `/#${this.openUrl}?` + paramsList.filter(item => this.openQueryList.includes(item.key)).map(item => `${item.key}=${item.val}`).join('&')
      window.open(url)
    },
    reload() {
      this.checkSearch()
      this.showAudit = false
    }
  }
}
